import type { AcceptsChildren } from "@/theme"
import React from "react"

export type FormProps = AcceptsChildren
const style: React.CSSProperties = {
  // display: "flex",
  flex: 1,
  height: "100%",
  width: "100%",
}

/**
 * In web, we wrap forms in the native html component
 * so that the child text inputs cooperate
 *
 * TODO: This breaks ScrollViews on web
 */
export default function Form(props: FormProps) {
  return <form id={"form"} style={style} {...props} />
}
